import React, { createContext, useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// import axios from "axios";

const TranslateContext = createContext();

export const TranslateProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [translations, setTranslations] = useState({ en: {}, th: {} });

  return (
    <TranslateContext.Provider value={{ translations, language: i18n.language }}>
      {children}
    </TranslateContext.Provider>
  );
};

export const useTranslate = () => useContext(TranslateContext);
